import { useState } from "react";

export function useDropbox() {
  const [dropboxAccessToken, setDropboxAccessToken] = useState(
    () => localStorage.getItem("dropboxAccessToken") || null
  );
  const [dropboxRefreshToken, setDropboxRefreshToken] = useState(
    () => localStorage.getItem("dropboxRefreshToken") || null
  );
  const [showFolderBrowser, setShowFolderBrowser] = useState(false);
  const [dropboxFolders, setDropboxFolders] = useState([]);
  const [currentPath, setCurrentPath] = useState("");
  const [selectedFolder, setSelectedFolder] = useState("");
  const [loadingFolders, setLoadingFolders] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploadingToDropbox, setIsUploadingToDropbox] = useState(false);

  return {
    dropboxAccessToken,
    dropboxRefreshToken,
    setDropboxAccessToken,
    setDropboxRefreshToken,
    showFolderBrowser,
    setShowFolderBrowser,
    dropboxFolders,
    setDropboxFolders,
    currentPath,
    setCurrentPath,
    selectedFolder,
    setSelectedFolder,
    loadingFolders,
    setLoadingFolders,
    selectedFile,
    setSelectedFile,
    isUploadingToDropbox,
    setIsUploadingToDropbox,
  };
}
